export const schema = {
  type: "object",
  properties: {
    status: { type: "string" },
    priority: { type: "string" },
    caseorigin: { type: "string" },
    caseowner: { type: "string" },
    contactname: { type: "string" },
    accountname: { type: "string" },
    subject: { type: "string" },
    description: { type: "string" },
  },
};
